import React, { useEffect, useMemo, useRef, useState } from "react";

import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import WindowedSelect from "react-windowed-select";
import {
  Alert,
  Button,
  Card,
  CardFooter,
  Col,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from "reactstrap";
import Loader from "../../../common/Loader";
import Columns2 from "../Columns2";
import { customComponents, customFilter } from "./OptionsCustomSelect";

const AsociarDocumentoGuardar = ({
  ShowAssociateDocument,
  setShowAssociateDocument,
  handleClearAsociarDocumentoProcesar,
  transformedOptionsAsociarDocumento,
  SelectedDocumentNumber,
  setSelectedDocumentNumber,
  inputFile,
  handleFileChange,
  setSelectedFile,
  handleAsociarDocumentoProcesar,
  getPageData2,
  currentPage2,
  pageSize2,
  ListAsociarDocumentoProcesar,
  sizePerPageList,
  handleSizePerPageChange2,
  handlePageChange2,
  handleOpenDocument2,
  handleSelectedtypeDocument,
  ListTypeDocument,
  fetching,
  handleGuardarAsociacionDocument,
  setListAsociarDocumentoProcesar,
  ValidAsociarDocumento,
  assigned,
}) => {
 /* if (assigned[0]?.isIrch) {
    ValidAsociarDocumento.TypesRequired = false;
  }*/
  
  return (
    <Modal
      size="xl"
      fade={false}
      centered={true}
      isOpen={ShowAssociateDocument}
      toggle={() => {
        setShowAssociateDocument(!ShowAssociateDocument);
        handleClearAsociarDocumentoProcesar();
      }}
      className="modal-dialog-scrollable"
      backdrop="static"
      keyboard={false}
    >
      <ModalHeader
        toggle={() => {
          setShowAssociateDocument(!ShowAssociateDocument);
          handleClearAsociarDocumentoProcesar();
        }}
      >
        Asociar documento
      </ModalHeader>
      <ModalBody>
        <Col lg={12}>
          <Card>
            <Row className="align-items-center">
              <Col lg={3}>
                <Label className="ml-2">Asociar documento:</Label>

                <WindowedSelect
                  options={transformedOptionsAsociarDocumento}
                  components={customComponents}
                  isClearable={true}
                  isMulti={false} // Por ejemplo, permite selección múltiple
                  placeholder="Selecciona una opción"
                  filterOption={customFilter}
                  value={SelectedDocumentNumber}
                  onChange={(x) => setSelectedDocumentNumber(x)}
                />
              </Col>
              <Col lg={4}>
                <Label className="mr-2">Archivos:</Label>
                <div className="input-group">
                  <input
                    type="file"
                    className="form-control"
                    id="customFile"
                    accept=".pdf"
                    ref={inputFile}
                    onChange={(e) => handleFileChange(e, setSelectedFile)}
                  />
                </div>
              </Col>
              <Col
                lg={2}
                className="d-flex align-items-end mt-auto justify-content-between"
              >
                <Button
                  className="btn "
                  color="primary"
                  onClick={() => {
                    handleAsociarDocumentoProcesar();
                  }}
                >
                  Procesar
                </Button>
                <Button
                  className="btn "
                  color="link"
                  onClick={handleClearAsociarDocumentoProcesar}
                >
                  Limpiar
                </Button>
              </Col>
            </Row>
            <Row className="mt-4">
              <Col lg={8} sm={12} >
                <div
                  className="table table-responsive"
                  style={{ overflowY: "auto", maxHeight: "300px" }}
                >
                  <Loader isLoading={fetching}>
                    <BootstrapTable
                      key={"custom_table"}
                      remote={true}
                      pagination={
                        getPageData2()?.length > 0
                          ? paginationFactory({
                              page: currentPage2,
                              sizePerPage: pageSize2,
                              totalSize:
                                ListAsociarDocumentoProcesar?.attachs.length,
                              sizePerPageList: sizePerPageList,
                              onSizePerPageChange: handleSizePerPageChange2,
                            })
                          : null
                      }
                      onTableChange={handlePageChange2}
                      columns={Columns2(
                        handleOpenDocument2,
                        handleSelectedtypeDocument,
                        ListTypeDocument
                      )}
                      data={getPageData2()}
                      keyField={"itemId"}
                      responsive={true}
                      bordered={false}
                      striped={true}
                      classes={
                        "table align-middle table-nowrap table-sm customTable"
                      }
                      noDataIndication={
                        <span className="no-data-message">
                          No hay datos disponibles
                        </span>
                      }
                      headerWrapperClasses={"thead-light"}
                    />
                  </Loader>
                </div>
              </Col>

              <Col lg={4} sm={12}>
                <textarea
                  id="basicpill-address-input1"
                  className="form-control mt mb-4"
                  rows="5"
                  placeholder={"Observación "}
                  value={ListAsociarDocumentoProcesar?.observation}
                  disabled={getPageData2()?.length == 0}
                  onChange={(e) => {
                    if (getPageData2()?.length == 0) {
                      return;
                    }
                    const inputValue = e.target.value;

                    // Reemplaza múltiples espacios en blanco entre palabras con un solo espacio en blanco
                    const sanitizedInput = inputValue.replace(/\s+/g, " ");

                    // Verifica si el valor contiene al menos un carácter diferente de un espacio en blanco o si es una cadena vacía
                    if (
                      /^\s*$/.test(sanitizedInput) ||
                      sanitizedInput.length > 0
                    ) {
                      setListAsociarDocumentoProcesar({
                        ...ListAsociarDocumentoProcesar,
                        observation: sanitizedInput,
                      });
                    }
                  }}
                ></textarea>
              </Col>
              {ListAsociarDocumentoProcesar?.attachs?.length > 0&& (ValidAsociarDocumento?.allRequired ||ValidAsociarDocumento?.TypesRequired) &&
                 (
                  <Alert color="warning">
                    {" "}
                   <p style={{margin:0}}>
                    { ValidAsociarDocumento?.allRequired && 'Es necesario seleccionar todos los tipos de documento de cada página. '}
                    { ValidAsociarDocumento?.TypesRequired && <strong> {`${ValidAsociarDocumento?.allRequired? 'Además, se' : 'Se'}`} deben seleccionar los documentos requeridos {ValidAsociarDocumento?.nameTypeRequired}.</strong>}
                   
                   </p>
                    {" "}
                  </Alert>
                )}
              
             
            </Row>

            <CardFooter className="d-flex justify-content-center">
              <Button
                className="btn btn-success"
                disabled={ValidAsociarDocumento?.allRequired ? ValidAsociarDocumento?.TypesRequired : ValidAsociarDocumento?.TypesRequired}
                onClick={() => {
                  handleGuardarAsociacionDocument();
                }}
              >
                Guardar
              </Button>
            </CardFooter>
          </Card>
        </Col>
      </ModalBody>
    </Modal>
  );
};

export default AsociarDocumentoGuardar;
